/**
 * @author Sai Prasad
 * @class KeyPickupServiceRequestList
 */
import React from 'react';
import Table from '../../components/Table';
import IcoMoon from '../../components/IcoMoon';
import Status from '../../components/Status';
import { ICONS } from '../../common/constants';

const KeyPickupServiceRequestList = ({
    serviceRequests
}) => {
    return (
        <div>
            <h3 style={{ marginTop: '2%' }}>Service Requests</h3>
            <Table
                columns={[
                    {
                        label: "Room/Area",
                        accessor: "area.name",
                    },
                    {
                        label: "Asset",
                        accessor: "itemName",
                    },
                    {
                        label: "Description",
                        cell: (data) => <div title={data.description} className='cut-text'>{data.description}</div>,
                    },
                    {
                        label: "Status",
                        cell: (data) => (
                            <Status
                                icon={<IcoMoon glyph={ICONS[data.status]} />}
                                label={data.status}
                            />
                        ),
                    }
                ]}
                data={serviceRequests}
            />
        </div>
    )
}

export default KeyPickupServiceRequestList;